import React, {useState} from 'react';
import { setHash, basePath } from '../../utils/help';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';

import {ReactComponent as PlayBtn} from '../../assets/svg/play.svg';
import {ReactComponent as RecommendsBtn} from '../../assets/svg/recommends.svg';

import classes from './StartPage.module.scss';

const Popup = (props) => (
  <div className={classes.Popup}>
    <div className={classes.Window}>
      <div className={classes.content}>{props.children}</div>
      <div className={classes.close} onClick={props.closePopup}>&#10006;</div>
    </div>
  </div>
);

const profTitles = {
  no_type: "не выбран тип",
  mountain: "горнодобывающая промышленность",
  pedagogical: "педагогика",
  legal: "правоохранительная сфера и управление",
  fuel: "топливно-энергетический комплекс",
  tourist: "туризм и сфера услуг",
  medicine: "клиническая и профилактическая медицина",
  mass_media: "средства массовой информации и коммуникационные технологии",
};

const profIcons = {
  no_type: "",
  mountain: "rocks.png",
  pedagogical: "book.png",
  legal: "shield.png",
  fuel: "fire.png",
  tourist: "camp.png",
  medicine: "medicine.png",
  mass_media: "news.png",
};

const profColors = {
  no_type: ["#fff","#fff","#fff"],
  mountain: ["#a7a9ac","#7e1c23","#376e92"],
  pedagogical: ["#486cc7","#d65616","#7a0b22"],
  legal: ["#796d1d","#ff797f","#bd505e"],
  fuel: ["#ff797f","#604381","#4f164e"],
  tourist: ["#008164","#a12b47","#ffa51f"],
  medicine: ['#00b1c8','#8f5791','#5e3d5d'],
  mass_media: ['#009bad','#ba9072','#8d6067'],
}

const StartPage = props => {
  const { showStartPage, startPage, closeStartPage } = props;
  const [showPopup, setShowPopup] = useState("");

  const openPopup = (content) => {
    setShowPopup(ReactHtmlParser(content));
  }

  const openModule = (url) => {
    setHash(url);
    closeStartPage();
  }

  const closePopup = () => {
    setShowPopup("");
  }

  const connectDescriptions = (desc1: string | undefined, desc2: string | undefined) => {
    let desc = "";
    const separator = `<br><br>
    <div style='width: 100%;height: 3px;background-color: black';></div>
    <br><br>`;

    if (desc1 != undefined && desc1 != "") desc += desc1;
    if (desc2 != undefined && desc2 != "") {
      if (desc.length > 0) desc += separator;
      desc += desc2
    }

    return desc;
  }

  if (!showStartPage) return null;

  const disciplineType = profColors[startPage.template_theme] ? startPage.template_theme : "no_type";

  return (
    <div className={classes.StartPage} style={{backgroundImage: `url(${startPage.background})`}}>
      {showPopup.length > 0 && (
        <Popup closePopup={closePopup}>{showPopup}</Popup>
      )}
      <div className={classes.Header}>
        <div className={classes.Line}>
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className={classes.UpperBlock}>
          <p>цифровой образовательный контент</p>
        </div>
        <div className={classes.BottomBlock}>
          <div className={classes.theme}>ТЕМА</div>
          <div className={classes.title}>
            {ReactHtmlParser(startPage.theme)}
          </div>
          <div className={classes.spo}>СПО</div>
        </div>
      </div>
      <div className={classes.Main}>
        <div className={classes.LeftBlock}>
          <div className={classes.Upper}>
            <div className={classes.Logo}>
              <div className={classes.prof}>
              <svg viewBox="0 0 500 500">
                <path id="curve" fill='transparent'
                  d="M 57.620642,173.63182 C 62.094147,165.81056 130.87426,49.517301 257.36256,51.05591 c 124.47523,1.53861 191.0186,115.7804 195.82761,124.37097"
                />
                <text width="500">
                  <textPath xlinkHref="#curve">
                    профессионалитет
                  </textPath>
                </text>
              </svg>
              </div>
              <div className={classes.year}>2023</div>
              <div className={classes.line} />
              <div className={classes.icon} style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/${profIcons[disciplineType]})`}} />
              <div className={classes.title}>{profTitles[disciplineType]}</div>
            </div>
            <div className={classes.Info}>
              {startPage.info && (<div className={classes.info} onClick={() => openPopup(startPage.info)}>Информация<br></br>о контенте</div>)}
              {startPage.tags && (<div className={classes.tags} onClick={() => openPopup(startPage.tags)}>Ключевые слова</div>)}
            </div>
          </div>
          <div className={classes.Bottom}>
            <div className={classes.TextBlock}>
              <div className={classes.title}>
                {ReactHtmlParser(startPage.fgosTitle)}
              </div>
              <div className={classes.text}>
                {ReactHtmlParser(startPage.fgosText)}
              </div>
            </div>
            <div className={classes.TextBlock}>
              <div className={classes.title}>
                {ReactHtmlParser(startPage.mdkTitle)}
              </div>
              <div className={classes.text}>
                {ReactHtmlParser(startPage.mdkText)}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.RightBlock}>
          {startPage.modules.map( (module, index) => (
            <div
              key={index}
              className={`${classes.Module} ${classes[`number_${index}`]}`}
              onClick={()=> openModule(module.url)}
            >
              <div className={`${classes.TitleBlock} ${classes[`number_${index}`]}`} style={{backgroundColor: profColors[disciplineType][index]}}>
                <div className={classes.icon} style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/module_${index+1}.png)`}}/>
                <div className={classes.title}>{ReactHtmlParser(module.title)}</div>                
              </div>
              <div className={classes.DescriptionBlock}>
                <span className={classes.text}>{ReactHtmlParser(module.mainTitle)}</span>
                <span className={classes.title}>{ReactHtmlParser(module.text)}</span>
              </div>
              <div className={classes.Line} style={{backgroundColor: profColors[disciplineType][index]}}/>
              <div className={classes.ButtonsBlock}>
                <PlayBtn
                  className={classes.playBtn}
                  style={{fill: profColors[disciplineType][index], stroke: profColors[disciplineType][index]}}
                />
                {(module.description || module.descriptionTeacher) && (
                  <RecommendsBtn
                    className={classes.recommendsBtn}
                    onClick={(event) => {event.stopPropagation(); openPopup(connectDescriptions(module.description, module.descriptionTeacher))}}
                    title="Методические материалы"
                    style={{ fill: profColors[disciplineType][index], stroke: profColors[disciplineType][index]}}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.Footer}>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/rocks.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/paper.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/book.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/line.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/bus.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/sheep.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/circle.png)`}}/>
        <div style={{backgroundImage: `url(${basePath}assets/images/startPage/type_B/wall.png)`}}/>
      </div>
    </div>
  )
}

StartPage.propTypes = {
  startPage: PropTypes.shape({
    template_type: PropTypes.string,
    template_theme: PropTypes.string,
    fgosTitle: PropTypes.string.isRequired,
    fgosText: PropTypes.string.isRequired,
    mdkTitle: PropTypes.string.isRequired,
    mdkText: PropTypes.string.isRequired,
    mainImg: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    tags: PropTypes.string,
    info: PropTypes.string,
    modules: PropTypes.arrayOf(PropTypes.any).isRequired,
  }).isRequired,
  closeStartPage: PropTypes.func.isRequired,
  showStartPage: PropTypes.bool.isRequired,
}

export default StartPage;
